import { gql } from '@apollo/client';

export const GET_COUNT = gql`
query countPayments($input: PaymentSearchInput) {
  countPayments(input: $input)
}
`;
